<template>
	<div class="row">
		<div class="col-xs-12">
			<div v-show="!loading && currentData.length > 0" class="chart">
				<canvas ref="canvas" width="100%" height="100%"></canvas>
			</div>
			<div v-show="loading" class="loading-message">
				<i class="fa fa-fw fa-circle-notch fa-spin fa-lg"></i> Carregando...
			</div>
		</div>
	</div>
</template>

<script>
import Chart from 'chart.js/dist/chart.min';

export default {
	name: "ChartDoughnut",

	props: [ "currentData", "loading" ],
	
	data: function() {
		return {
            chart: null,
			config: {
				type: "doughnut",
				data: {
					labels: [
						"Aguardando",
						"A caminho",
						"Finalizado",
						"Não entregue",
						"Desvinculada",
					],
					datasets: [
						{
							label: "Dataset 1",
							data: this.currentData,
							backgroundColor: [
								"rgba(170,170,170,.7)",
								"rgba(0,181,173,.7)",
								"rgba(0,255,0,.7)",
								"rgba(199,0,0,.7)",
								"rgba(100,100,100,.7)"
							],
						},
					],
				},
				options: {
					responsive: true,
					plugins: {
						legend: {
							display: true,
							position: "bottom",
							align: "start",
						},
					},
				},
			}
		}
	},

	mounted: function() {
		this.createChart();
	},

	watch: {
		currentData: function(newData) {
			// Atualiza as informações do data
			this.config.data.datasets[0].data = newData;

			// Remove o gráfico
			this.chart.destroy();
			
			// Cria o gráfico novamente
			this.createChart();
		}
	},

	methods: {
		createChart: function() {
			this.chart = new Chart(this.$refs.canvas, this.config);
		},
	},
}
</script>

<style scoped>
.chart {
	padding: 15px 0px;
}

.loading-message {
	padding: 15px;
	text-align: center;
}
</style>